import { render, staticRenderFns } from "./BaseComboBox.vue?vue&type=template&id=4df7814f&scoped=true"
import script from "./BaseComboBox.vue?vue&type=script&lang=js"
export * from "./BaseComboBox.vue?vue&type=script&lang=js"
import style0 from "./BaseComboBox.vue?vue&type=style&index=0&id=4df7814f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df7814f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
